module.exports = __webpack_public_path__ + "img/match-6.412e4cc1.webp";